import { useImpersonation } from '@/contexts/ImpersonationContext'

/**
 * Single derived predicate for the account-level gates that block a regular
 * end-user until they act (forced password change, onboarding / verification
 * status redirects, ...). (#1344)
 *
 * While an admin is impersonating, those prompts belong to the account owner,
 * not to the admin inspecting the account: the admin cannot change the
 * target's password, accept terms on their behalf, or finish their
 * onboarding — so every such gate must step aside for the duration of the
 * impersonation session. The backend already exempts impersonation tokens
 * from the forced-password 403 (#1207); this is the client-side twin.
 *
 * The impersonation flag is read from ImpersonationContext (the auth context
 * cannot consume it — AuthProvider is mounted *outside* ImpersonationProvider
 * in App.tsx), so callers must render inside ImpersonationProvider, which
 * every protected route does.
 */
export function useAccountGateBypass(): { shouldBypassAccountGates: boolean } {
  const { isImpersonating } = useImpersonation()
  return { shouldBypassAccountGates: isImpersonating }
}
